import Navbar from '../navigation/Navbar';
import Footer from './Footer'; // Importamos el nuevo Footer

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col bg-[#050505] text-white font-sans selection:bg-[#C5A059] selection:text-[#050505]">
      <Navbar />
      
      {/* El contenido principal empuja el footer hacia abajo */}
      <main className="flex-grow">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Layout;